<template> 
  <div
    v-if="processStatus == 'init'"
    class="text-base font-normal text-grayCust-500 break-word focus:outline-0 focus-visible:outline-0"
    v-html="template.display_text_launch"
  />
  <div v-if="processStatus == 'in_process'">
    <Form
      :template="template"
      :price="price"
      :interval="interval"
      :form="form"
      :errors="errors"
      :monetize="template.is_monetized"
      :is-user-exist="isUserExist"
      @click_add_card="addCardClick"
    />
  </div>
  <div v-if="processStatus == 'payment_process'">
    <PaymentStatus
      :purchase-status="purchaseStatus"
      :fail-reason="failReason"
      @start-process="startProcess"
    />
  </div>

  <div v-if="processStatus == 'site_creating'">
    <Progressbar
      :percentage="progressPercentage"
      :status="progressStatus"
      :heading="progressHeading"
      :sub-heading="progressSubHeading"
      @start-process="startProcess"
    />
  </div>
  <div v-if="processStatus == 'complete'">
    <SiteDetails
      v-if="!template.auto_launch"
      :detail="siteDetails"
      :template="template"
      :price="price"
    />
    <div
      v-else
      class="w-full sm:max-w-2xl mt-6 px-6 py-4"
    >
      <p
        v-if="processing"
        class="text-center flex items-center mb-10"
      >
        <svg
          :class="{ 'animate-spin': processing,}"
          class="h-6 w-6"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 20V15H4.58152M19.9381 13C19.446 16.9463 16.0796 20 12 20C8.64262 20 5.76829 17.9318 4.58152 15M4.58152 15H9M20 4V9H19.4185M19.4185 9C18.2317 6.06817 15.3574 4 12 4C7.92038 4 4.55399 7.05369 4.06189 11M19.4185 9H15"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="ml-1 mr-1"> {{ $t('redirected_admin_panel') }} </span>
      </p>
      <p
        v-else
        class="text-center mb-20"
      >
        {{ errors.site }}
      </p>
    </div>
  </div>
</template>

<script>

import Progressbar from "@/Common/Progressbar.vue";
import SiteDetails from '@/Common/SiteDetails.vue';
import Form from '@/components/Template/SharedLaunch/Form.vue';
import PaymentStatus from '@/components/Template/SharedLaunch/PaymentStatus.vue';
import JetInputError from "@/Jetstream/InputError.vue";
 
export default {
    name: "Body",
    components: {
        JetInputError,
        PaymentStatus,
        Form,
        Progressbar,
        SiteDetails
    },
    props:{
        price: {
            default: 0,
            type: Number,
        },
        interval: {
            default: '',
            type: String,
        },
        processStatus: {
            default: 'init',
            type: String,
            required: true
        },
        purchaseStatus: {
            default: '',
            type: String,
        },
        template: {
            required: true,
            type: Object,
        },
        form: {
            type: Object,
            default: {
                name: "",
                email: "",
            }
        },
        errors: {
            type: Object,
            default: {
                name: "",
                email: "",
            }
        },
        failReason: {
            type: String,
            default: ''
        },
        progressPercentage: {
            default: 0,
            type: Number,
        },
        progressStatus: {
            default: '',
            type: String,
            required: true
        },
        progressHeading: {
            default: '',//this.$t('installation_in_progress'),
            type: String,
        },
        progressSubHeading: {
            default: '',
            type: String,
        },
        siteDetails: {
            default: null,
            type: Object,
        },
        processing: {
            type: Boolean,
        },
        isUserExist: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            monetize: this.template.is_monetized,
        }
    },
    methods: {
        startProcess() {
            this.$emit('startProcess');
        },
        addCardClick(){
            this.$emit("click_add_card")
        }
    }
}
</script>
